import { render } from "./SizeTableCard.vue?vue&type=template&id=5da041fc&scoped=true"
import script from "./SizeTableCard.vue?vue&type=script&lang=js"
export * from "./SizeTableCard.vue?vue&type=script&lang=js"

import "./SizeTableCard.vue?vue&type=style&index=0&id=5da041fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da041fc"]])

export default __exports__